var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { TileMode } from '@mitchell/react.component.ux';
import { TranslationService, EnterpriseDocStoreService } from "../../common";
import { downloadAartifactsGalleryProps, PhotoCaptureConstants } from '../constants';
import { PhotoCapture } from '../enums';
import { ImageAlbumOrganizer, downloadFiles } from '../utilities';
import { PhotoCaptureNavigationControlComponent } from './PhotoCaptureNavigationControlComponent';
import { GalleryContainer } from './GalleryContainer';
export const DownloadArtifactsGalleryComponent = ({ photoCaptureAttachmentInfo, appTheme, countryCode, language, onDownloadStart, onDownloadComplete }) => {
    const translateFn = TranslationService.translate;
    const [downloadAlbums, setDownloadAlbums] = React.useState([]);
    const [downloadTileDocIds, setDownloadTileDocIds] = React.useState([]);
    React.useEffect(() => {
        const { albums, tileDocIds } = ImageAlbumOrganizer.organizeImagesIntoAlbums(photoCaptureAttachmentInfo || [], countryCode, language);
        setDownloadAlbums(albums);
        setDownloadTileDocIds(tileDocIds);
    }, [photoCaptureAttachmentInfo]);
    const toggleTileSelectionState = (albums, updater) => {
        return albums.map((album) => (Object.assign(Object.assign({}, album), { tiles: album.tiles.map((tile) => updater(tile)), subAlbums: album.subAlbums &&
                album.subAlbums.map((subAlbum) => (Object.assign(Object.assign({}, subAlbum), { tiles: subAlbum.tiles.map(tile => updater(tile)) }))) })));
    };
    const onTileClick = (tileId, isSelected) => {
        setDownloadAlbums((prevAlbums) => toggleTileSelectionState(prevAlbums, (tile) => tile.id === tileId ? Object.assign(Object.assign({}, tile), { isSelected }) : tile));
    };
    const handleDeselectImages = () => {
        setDownloadAlbums((prevAlbums) => toggleTileSelectionState(prevAlbums, (tile) => (Object.assign(Object.assign({}, tile), { isSelected: false }))));
    };
    const handleDownloadImages = (isDownloadSelected) => __awaiter(void 0, void 0, void 0, function* () {
        // First, find all selected tiles with their IDs and fileNames
        const selectedTiles = [];
        downloadAlbums.forEach(album => {
            album.tiles.forEach(tile => {
                if (tile.isSelected || !isDownloadSelected) {
                    selectedTiles.push({
                        id: tile.id,
                        fileName: tile.fileName
                    });
                }
            });
            if (album.subAlbums) {
                album.subAlbums.forEach((subAlbum) => {
                    subAlbum.tiles.forEach((tile) => {
                        if (tile.isSelected || !isDownloadSelected) {
                            selectedTiles.push({
                                id: tile.id,
                                fileName: tile.fileName
                            });
                        }
                    });
                });
            }
        });
        const filesToBeDownloaded = [];
        onDownloadStart();
        // Then, match with docUIDs from downloadTileDocIds
        const enterprise = new EnterpriseDocStoreService();
        for (const selectedTile of selectedTiles) {
            const matchingDocItem = downloadTileDocIds.find(item => Number(item.tileId) === selectedTile.id);
            if (matchingDocItem) {
                yield enterprise.getFileBlob(matchingDocItem.docUID).then(blob => {
                    filesToBeDownloaded.push(new File([blob], selectedTile.fileName));
                });
            }
        }
        onDownloadComplete();
        downloadFiles(filesToBeDownloaded);
        if (isDownloadSelected) {
            handleDeselectImages();
        }
    });
    const isAnyTileSelected = React.useMemo(() => {
        return downloadAlbums.some((album) => album.tiles.some((tile) => tile.isSelected) ||
            (album.subAlbums &&
                album.subAlbums.some((subAlbum) => subAlbum.tiles.some((tile) => tile.isSelected))));
    }, [downloadAlbums]);
    return (React.createElement(React.Fragment, null,
        React.createElement(GalleryContainer, Object.assign({ id: "Gallery__Attachments-select-mode", mode: TileMode.SMALL, albums: downloadAlbums, onTileClick: onTileClick }, downloadAartifactsGalleryProps)),
        !!downloadAlbums.length && (React.createElement(PhotoCaptureNavigationControlComponent, { buttonBackgroundColor: appTheme.buttonBackgroundColor, buttonTextColor: appTheme.buttonTextColor, idPrefix: `${PhotoCapture.GUIDED_PHOTO_CAPTURE}_galleryNavigationControlComponent`, disabledButtonBackgroundColor: appTheme.disabledButtonBackgroundColor, disabledButtonTextColor: appTheme.disabledButtonTextColor, onLeftClick: () => {
                handleDownloadImages(true);
            }, onRightClick: () => handleDownloadImages(false), shouldLeftButtonDisabled: !isAnyTileSelected, leftButtonLabel: translateFn(PhotoCaptureConstants.DOWNLOAD_SELECTED), rightButtonLabel: translateFn(PhotoCaptureConstants.DOWNLOAD_ALL), shouldNextButtonDisabled: false }))));
};
//# sourceMappingURL=DownloadArtifactsGalleryComponent.js.map